<template>
  <div
    class="alert alert-dark mb-5"
    :transitionDuration="'500ms'"
    :isOpen="false"
    :transitionTimingFunction="'ease-in-out'"
    :openLabel="'Nyitva'"
  >
    <div slot="closedTrigger">
      <div class="row">
        <div class="text-white col-sm-8">
          <h1>
            Részletek
          </h1>
        </div>
      </div>
      <div class="col-md-8">
        <div class="form-group row mb-2">
          <label for="chosenSport" class="col-sm-6 fw-bold">A választott sportág:</label>
          <div class="col-sm-6">
            <input id="chosenSport" type="text" class="form-control" disabled :value="sportNames[chosenSport]" />
          </div>
        </div>
        <div class="form-group row mb-2">
          <label for="chosenPackage" class="col-sm-6 fw-bold">A választott csomag:</label>
          <div class="col-sm-6">
            <input id="chosenPackage" type="text" class="form-control" disabled :value="packageNames[chosenPackage]" />
          </div>
        </div>
        <div class="form-group row mb-2">
          <label for="evesDij" class="col-sm-6 fw-bold">A biztosítás éves díja összesen:</label>
          <div class="col-sm-6">
            <input
              id="evesDij"
              type="text"
              class="form-control"
              disabled
              :value="$store.state.kieg_emelt_eves_dij | currency"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {parse as parseMoney} from 'vue-currency-input';
import RecalculateButton from './components/components/RecalculateButton.vue';
import RequestPdfButon from './components/components/RequestPdfButton.vue';
import DmButton from './components/components/DmButton.vue';
import Collapsible from './components/components/Collapsible.vue';
import SaveLinkButton from './components/components/SaveLinkButton.vue';
import {mapFields} from 'vuex-map-fields';
import 'animate.css';

export default {
  components: {
    RequestPdfButon,
    DmButton,
    Collapsible,
    SaveLinkButton,
    RecalculateButton,
  },

  data() {
    return {
      summaryPrice: 0,
      isCollapsed: false,
    };
  },
  computed: {
    mainPropertyInsurance() {
      const acceptInsurance = this.$store.state.insurancePersonalGoods.acceptCalculatedInsurance;

      if (acceptInsurance) return this.$store.state.insurancePersonalGoods.calculatedInsurancePrice;

      return this.$store.state.insurancePersonalGoods.allGoodsPrice;
    },
    ...mapFields(['sportNames', 'packageNames']),
    ...mapFields({
      chosenSport: 'generalInfo.chosenSport',
      chosenPackage: 'generalInfo.chosenPackage',
    }),
    paymentFrequentString() {
      const frequency = this.$store.state.paymentOptions.frequency;
      let stringFrequency;
      if (frequency == 'eves') stringFrequency = ' /év';
      else if (frequency == 'feleves') stringFrequency = ' /félév';
      else if (frequency == 'negyedeves') stringFrequency = ' /negyedév';
      else stringFrequency = ' /hó';
      return (
        this.$options.filters.currency(this.$store.state.gyakorisag_szerint_fizetendo_dij) +
        stringFrequency
      );
    },
    ClamIdentifie() {
      return this.$store.state.code;
    },
  },
  methods: {
    calculateSummaryPrice(data) {
      let price = 0;
      for (const [key, value] of Object.entries(data)) {
        if (typeof value === 'string') {
          const parsedInt = parseMoney(value, window.currencyInputOptions);
          if (parsedInt) price += parsedInt;
        }
      }
      this.summaryPrice = price;
    },
    generateClaimIdentifier(code) {
      this.$store.commit('setClaimIdentifier', code);
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 768px) {
  .claim-identifier {
    max-width: max-content !important;
  }
}
$red: #e4002b;
.arrow-up {
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  float: right;
  border-bottom: 20px solid white;
  // margin-left: 80%;
  margin-bottom: 5%;
  //display: inline-block;
  cursor: pointer;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  float: right;
  border-top: 20px solid white;
  //margin-left: 80%;
  margin-bottom: 5%;
  //display: inline-block;
  cursor: pointer;
}

b {
  float: right;
}
h1 {
  color: white !important;
}
</style>
